import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import WaitingImage from 'assets/images/members.webp';

import './ShareableLinkNdaCountersign.styles.scss';

type ShareableLinkNdaCountersignProps = {
  className?: string;
};

const ShareableLinkNdaCountersign: React.FC<
  ShareableLinkNdaCountersignProps
> = (props) => {
  const { className } = props;

  const classes = classNames('shareable-link-nda-countersign', className);

  const { t } = useTranslation();

  return (
    <ShareableLinkLockScreen
      className={classes}
      image={WaitingImage}
      title={t('waitingNdaCounter')}
      description={t('waitingNdaCounterDescription')}
    />
  );
};

export default ShareableLinkNdaCountersign;
